<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="alert"></a-icon>
          <span>屏蔽策略</span>
        </a-space>
      </template>
      <span>告警屏蔽策略包含严重性、生效时间等。</span>
    </a-page-header>
    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnDefaultSelected="columnDefaultSelected"
        :columnsAll="columnsAll"
        :toolsList="['setting', 'reload', 'search', 'leftTool']"
        :refresh="refresh"
        :defaultSelected="tableSelectData"
        @tableSelectData="v => (tableSelectData = v)"
        :table-operation-width="120"
      >
        <!-- 工具栏 -->
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.alert_block_strategy.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          >
          </create-button>
        </template>
        <!-- 表格自定义列 -->
        <template #name="{ slotProps }">
          <a-tooltip placement="topLeft" :title="slotProps.text">
            <a @click="$refs.inputDrawer.show(slotProps.record.id)">
              {{ slotProps.text }}
            </a>
          </a-tooltip>
        </template>
        <template #severities="{ slotProps }">
          <alert-severity-tag
            v-for="severity in slotProps.text"
            :key="severity"
            :severity="severity"
          ></alert-severity-tag>
        </template>
        <template #daily="{ slotProps }">
          <a-tag color="#1890ff">{{ slotProps.text ? '每日' : '单次' }}</a-tag>
        </template>
        <template #range="{ slotProps }">
          <a-tooltip
            placement="topLeft"
            :title="
              slotProps.record.daily
                ? `${slotProps.record.time_from} ~ ${slotProps.record.time_to}`
                : `${slotProps.record.datetime_from} ~ ${slotProps.record.datetime_to}`
            "
          >
            {{
              slotProps.record.daily
                ? `${slotProps.record.time_from} ~ ${slotProps.record.time_to}`
                : `${slotProps.record.datetime_from} ~ ${slotProps.record.datetime_to}`
            }}
          </a-tooltip>
        </template>
        <template #conditions="{ slotProps }">
          {{ `${slotProps.record.conditions.length} 条` }}
        </template>
        <template #active="{ slotProps }">
          <boolean-tag :value="slotProps.text"></boolean-tag>
        </template>
        <template #operation="{ slotProps }">
          <delete-button
            v-permission="{action: 'base.alert_block_strategy.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @updated="confirm()"></input-drawer>
  </div>
</template>

<script>
import {
  deleteAlertBlockStrategy,
  getAlertBlockStrategyList
} from '@/api/alert-block-strategy'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import CreateButton from '@/components/button/CreateButton'
import AlertSeverityTag from '@/components/tag/AlertSeverityTag'
import BooleanTag from '@/components/tag/BooleanTag'
import InputDrawer from './modules/InputDrawer'

export default {
  name: 'AlertBlockStrategy',
  components: {
    AlertSeverityTag,
    BooleanTag,
    DeleteButton,
    InputDrawer,
    CreateButton,
    ListLayout
  },
  data () {
    return {
      getTableDataFunc: getAlertBlockStrategyList,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'severities',
          title: '严重性',
          width: 240,
          scopedSlots: {
            customRender: 'severities'
          }
        },
        {
          dataIndex: 'daily',
          title: '生效周期',
          width: 100,
          scopedSlots: {
            customRender: 'daily'
          }
        },
        {
          dataIndex: 'range',
          title: '生效时间',
          width: 260,
          ellipsis: true,
          scopedSlots: {
            customRender: 'range'
          }
        },
        {
          dataIndex: 'conditions',
          title: '条件配置',
          align: 'center',
          width: 100,
          scopedSlots: {
            customRender: 'conditions'
          }
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        },
        {
          dataIndex: 'active',
          title: '状态',
          width: 100,
          scopedSlots: {
            customRender: 'active'
          },
          filters: [
            {
              text: '启用',
              value: 'true'
            },
            {
              text: '停用',
              value: 'false'
            }
          ],
          filterMultiple: false
        }
      ],
      columnDefaultSelected: [
        'name',
        'severities',
        'daily',
        'range',
        'conditions',
        'active'
      ],
      refresh: false,
      tableSelectData: []
    }
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteAlertBlockStrategy(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(
          this.tableSelectData.findIndex(item => item.key === id),
          1
        )
      }
      this.refresh = !this.refresh
    }
  }
}
</script>
